import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.offcanvas = new bootstrap.Offcanvas(this.element, {
      backdrop: 'static'
    });
  }

  open() {
    if (!this.offcanvas.isOpened) {
      this.offcanvas.show();
    }
  }

  hide() {
    this.offcanvas.hide();
  }

  close(event) {
    if (event.detail.success) {
      this.offcanvas.hide();
    }
  }
}
